import React, { useEffect, useState } from 'react'
import AgencyGroupTable from './agency-groups-table'
import AddNewAgencyGroupDialog from './dialogs/addNewAgencyGroup'
import ButtonBase from 'components/partials/button'
import { useLazyQuery } from '@apollo/client'
import { GET_ALL_AGENCY_GROUP } from 'queries/admin/agencyGroup'
import { IAgencyGroup } from '../interface'
import { notify } from 'components/toastify'
import { STATUS } from 'constants/messages'
import { useSession } from 'helpers/checkSession'

interface Props {}

const LIMIT = 5

const AgencyGroup: React.FC<Props> = () => {
  const { handleErrorSession } = useSession()
  const [isOpenCreateNewAgencyGroupDialog, setIsOpenCreateNewAgencyGroupDialog] =
    useState<boolean>(false)
  const [tableData, setTableData] = useState<IAgencyGroup[]>([])
  const [hasMoreData, setHasMoreData] = useState<boolean>(true)

  const [loadAgencyGroups, { fetchMore, loading }] = useLazyQuery(GET_ALL_AGENCY_GROUP, {
    variables: { skip: 0, take: LIMIT },
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      setTableData(data.getAllAgencyGroup)
      setHasMoreData(data.getAllAgencyGroup.length === LIMIT)
    },
    onError: (error) => {
      if (error.message) {
        handleErrorSession(error, error.message)
      } else {
        notify('Something wrong', STATUS.ERROR)
      }
    },
  })

  const handleRefetch = () => {
    loadAgencyGroups({
      variables: { skip: 0, take: LIMIT },
      fetchPolicy: 'network-only',
      onCompleted: (data) => {
        setTableData(data.getAllAgencyGroup)
      },
      onError: (error) => {
      if (error.message) {
        handleErrorSession(error, error.message)
      } else {
        notify('Something wrong', STATUS.ERROR)
      }
    },
    })
  }

  const handleFetchMore = () => {
    if (!fetchMore) return

    fetchMore({
      variables: {
        skip: tableData.length,
        take: LIMIT,
      },
    }).then(({ data: fetchMoreData }) => {
      if (fetchMoreData?.getAllAgencyGroup) {
        setTableData((prev) => [...prev, ...fetchMoreData.getAllAgencyGroup])
      }
    })
  }

  const onClickAddNewBtn = () => {
    setIsOpenCreateNewAgencyGroupDialog(true)
  }

  const handleCloseCreateDialog = () => {
    handleRefetch()
    setIsOpenCreateNewAgencyGroupDialog(false)
  }

  useEffect(() => {
    loadAgencyGroups()
  }, [])

  return (
    <div className="px-20 py-5 md:px-10">
      <div className="grid grid-flow-col justify-items-end pb-2">
        <ButtonBase
          className="disabled:bg-primary-shade3"
          bgHover="Add new a group agency for custom"
          onClick={onClickAddNewBtn}
        >
          Add new
        </ButtonBase>
      </div>
      <AgencyGroupTable
        tableData={tableData}
        handleFetchMore={handleFetchMore}
        handleRefetch={handleRefetch}
        hasMoreData={hasMoreData}
        isLoading={loading}
      />

      {isOpenCreateNewAgencyGroupDialog && (
        <AddNewAgencyGroupDialog
          isOpenDialog={isOpenCreateNewAgencyGroupDialog}
          handleCloseDialog={handleCloseCreateDialog}
        />
      )}
    </div>
  )
}

export default AgencyGroup
